import { normalizePhone, getPureDate } from 'utils/helpers';

const MESSAGE_ERROR = 'Обязательное поле';
const MESSAGE_INVALID_EMAIL = 'Неправильный email';
const MESSAGE_INVALID_PHONE = 'Неправильный номер телефона';
const MESSAGE_INVALID_YEAR = 'Неправильное значение года';
const MESSAGE_INVALID_LENGTH = 'Неверная длина';
const MESSAGE_IRRELEVANT_DATE = 'Неверная дата';


export const required = (value: any) => {
  let error;
  if (typeof value === 'string' ? !value.trim() : !isNaN(value.length) ? !value.length : !value) {
    error = MESSAGE_ERROR;
  }
  return error;
}

export const isRelevantDate = (value: any) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (getPureDate(value, 'X') < getPureDate(new Date(), 'X')) {
    error = MESSAGE_IRRELEVANT_DATE;
  }
  return error;
}

export const isEmail = (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = MESSAGE_INVALID_EMAIL;
  }
  return error;
}

export const isPhone = (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (normalizePhone(value).length !== 11) {
    error = MESSAGE_INVALID_PHONE;
  }
  return error;
}

export const isYear = (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (!/^\d{4}$/.test(value)) {
    error = MESSAGE_INVALID_YEAR;
  }
  return error;
}


export const checkLength = (length: number) => (value: string) => {
  let error;
  if (!value) {
    error = MESSAGE_ERROR;
  } else if (value.length < length) {
    error = MESSAGE_INVALID_LENGTH;
  }
  return error;
}